import { render, staticRenderFns } from "./StoryTagsList.vue?vue&type=template&id=5d62b98c"
import script from "./StoryTagsList.vue?vue&type=script&lang=js"
export * from "./StoryTagsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports